export default "__VITE_ASSET__8f01b214__"